module.exports = __webpack_public_path__ + "static/media/icon.bfca53ab.png";